function ContactAccessOnly(can: any) {
  can("access", "Contact_Menu");
  can("access", "View_Contact");
}
function AddContactOnly(can: any) {
  can("access", "Contact_Menu");
  can("create", "Add_Contact");
  can("update", "File_Contact");
}
function EditContactOnly(can: any) {
  can("access", "Contact_Menu");
  can("create", "Edit_Contact");
  can("update", "File_Contact");
}
function ExportContactOnly(can: any) {
  can("access", "Contact_Menu");
  can("create", "Export_Contact");
}
function ContactAccessDataAll(can: any) {
  can("accessData", "Contact_Access_Data_All");
}
function ContactAccessDataCustomerOnly(can: any) {
  can("accessData", "Contact_Access_Data_Customer");
}
function ContactAccessDataSellerOnly(can: any) {
  can("accessData", "Contact_Access_Data_Seller");
}
function DeleteContactOnly(can: any) {
  can("access", "Contact_Menu");
  can("update", "Delete_Contact");
  can("update", "Enable_Contact");
}

function ManageContact(manageContact: any, can: any) {
  if (manageContact) {
    if (manageContact.information && !manageContact.information.view) return;
    const { information, report, accessData } = manageContact;

    ContactAccessOnly(can);
    if (information) {
      if (information.create) AddContactOnly(can);
      if (information.edit) EditContactOnly(can);
      if (information.delete) DeleteContactOnly(can);
    }

    if (report && report.print) ExportContactOnly(can);

    if (accessData) {
      if (accessData.all) ContactAccessDataAll(can);
      else if (accessData.customer) ContactAccessDataCustomerOnly(can);
      else if (accessData.seller) ContactAccessDataSellerOnly(can);
    }
  }
}
export { ManageContact };
